<template>
  <div class="wim-paragraph-container tva-row">
    <div v-if="content.option === 'first'" class="wim-paragraph first tva-col-xs-offset-0 tva-col-xs-12 tva-col-sm-offset-2 tva-col-sm-8 tva-col-md-offset-2 tva-col-md-6">
        <p :lang="lang" class="black" v-html="content.text"></p>
        <!-- <div v-if="content.callout" class="wim-paragraph-callout">
          <h4 class="wim-callout-quote">{{content.callout}}</h4>
          <div class="wim-callout-poligon"></div>
        </div> -->
    </div>
    <div v-if="content.option === 'second'" class="wim-paragraph tva-col-xs-offset-0 tva-col-xs-12 tva-col-sm-offset-2 tva-col-sm-8 tva-col-md-offset-2 tva-col-md-6">
        <p :lang="lang" class="black" v-html="content.text"></p>
    </div>
    <!-- immagine JPG-->
    <div v-if="content.image && content.extension !== 'svg'" class="wim-paragraph-image tva-col-xs-offset-2 tva-col-xs-8 tva-col-sm-offset-2 tva-col-sm-5 tva-col-md-offset-1 tva-col-md-3">
      <img v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${content.image}${$retina ? '@2x' : ''}.jpg`" alt="image">
    </div>
    <!-- immagine SVG-->
    <div v-if="content.image && content.extension === 'svg'" class="wim-paragraph-image tva-col-xs-offset-2 tva-col-xs-8 tva-col-sm-offset-2 tva-col-sm-5 tva-col-md-offset-1 tva-col-md-3">
      <img v-lazy="baseUrl+'images/'+content.image+'.svg'" alt="image">
    </div>
    <!-- focus -->
    <div v-if="content.focus" class="wim-paragraph-focus tva-col-xs-offset-2 tva-col-xs-8 tva-col-sm-offset-2 tva-col-sm-5 tva-col-md-offset-1 tva-col-md-3">
      <FocusPreview :content="content.focus"/>
    </div>
    <!-- video -->
    <div v-if="content.video" class="wim-video-wrapper tva-col-xs-offset-2 tva-col-xs-8 tva-col-sm-offset-2 tva-col-sm-5 tva-col-md-offset-0 tva-col-md-3">
      <div class="wim-video-container">
      <video 
        class="wim-lazy-video"
        :poster="`${baseUrl}images/${content.video}${$retina ? '@2x' : ''}.jpg`" 
        playsinline="true"
        loop="true"
        autoplay="true"
        muted="true" 
        style="position: absolute; top:0; width: calc(100% + 1px); left: -1px; max-width: none"
      >
        <source :data-src="`${baseUrl}images/${content.video}.mp4`" type="video/mp4">
      </video>  
      </div>
    </div>
  </div>
</template>
<script>
import LazyLoad from 'vanilla-lazyload'

import FocusPreview from './FocusPreview.vue'

export default {
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  mounted() {
    this.$nextTick(() => {
      var myLazyLoad = new LazyLoad({
          elements_selector: ".wim-lazy-video"
      });
    })
  },
  computed: {
    lang() {
      let lang = this.$route.params.lang;
      return lang ? lang.toLowerCase() : 'it'
    }
  },
  props: ["content"],
  components: {
    FocusPreview
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.wim-paragraph-container {
  margin: 10px 0;
  width: 100%;
  display:flex;
  flex-direction: row;
  align-items: center;
  .wim-paragraph {
    display: flex;
    align-items: center;
    text-align: justify;
    text-justify: inter-word;
    hyphens: auto;
    &.first p::first-letter {
      font-size: 90px;
      color: $beige;
      font-weight: 600;
      float: left;
      margin:30px 20px 20px 0;
    } 
    .wim-paragraph-callout {
      position:absolute;
      top:0;
      left:0;
      height: 100%;
      width: 530px;
      .wim-callout-quote {
        text-align: left;
      }
      .wim-callout-poligon {
        -webkit-shape-outside: polygon(0 0, 260px 0, 170px 410px, 0 260px);
        shape-outside: polygon(0 0, 260px 0, 170px 410px, 0 260px);
        -webkit-shape-outside: polygon(0 0, 260px 0, 170px 410px, 0 260px);
        clip-path: polygon(0 0, 260px 0, 170px 410px, 0 260px);
        background:blue;
        width: 50%;
        height: 100%;
        float:left;
        
      }
    }
  }
  .wim-paragraph-image img {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
  .wim-video-container {
    height: 0;
    padding-bottom: 56.25%;
    position: relative;
    video {
      width: 100%;
      position: absolute;
      top:0;
      left:0;
    }
  }
}
@media (max-width: 992px) {
  .wim-paragraph-container {
    display: block;
    .wim-paragraph-image,
    .wim-paragraph-focus,
    .wim-video-wrapper {
      padding-left: 0;
    }
  }
}
@media (max-width: 768px) {
  .wim-paragraph-container {
    width: 100%;
    margin:0;
    display:block;
    padding: 0 10px;
    .wim-paragraph {
      padding:0;
       &.first p::first-letter {
        font-size : 56px;
        margin:12px 10px 10px 0;
      }
      .wim-paragraph-callout {
        position: relative;
        width: 100%;
        .wim-callout-poligon {
          display:none;
        }
        .wim-callout-quote {
          height: 100%;
        }
      }
    }
    .wim-paragraph-image {
      padding: 0;
    }
    .wim-paragraph-focus {
      padding: 0;
    }
    .wim-video-wrapper {
      padding:0;
    }
    .wim-video-container {
      width: 100%;
    }
  }
}


</style>